
































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@/mixins/table.mixin';
import Modal from './property-widgets.modal.vue';

@Component({
  components: { Modal },
})
export default class PropertyWidgetsShell extends Mixins(TableMixin) {
  columns = [
    {
      label: 'GENERAL.STATUS',
      name: 'isActive',
      sortable: true,
      align: 'center',
    },
    { label: 'GENERAL.NAME', name: 'name', sortable: true },
    { label: 'GENERAL.TYPE', name: 'type', sortable: true },
    { label: 'GENERAL.ACTIONS', name: 'actions', align: 'center' },
  ];

  get propertyId() {
    return this.$route.params.propertyId;
  }

  normalizeDate(date: Date) {
    return date ? this.$formatDate(date) : '';
  }

  @Watch('modal.open')
  onClose(value: boolean) {
    if (!value) this.onUpdateData();
  }
}
